import { FontView, View } from '@packages/types'
import classNames from 'classnames'
import React, { forwardRef } from 'react'

import ExtraPriceLabel from 'themes/common/components/ExtraPriceLabel'
import Translation from 'themes/common/components/Translation'
import FontPreview from 'themes/common/components/FontPreview'
import RadioIcon from 'themes/common/components/answers/RadioIcon'
import isNullOrEmpty from 'utils/isNullOrEmpty'

interface RadioAnswerProps {
  handleClick: (id: string) => void
  id: string
  name: string
  selected: boolean
  views?: View[]
  price?: string | number
  currency: string
  lang?: string
  country?: string
  inputType: string
  style: {
    text: {
      color: string
      fontSize: string
      fontFamily: string
    }
    price: {
      fontFamily: string
      color: string
      borderColor: string
      backgroundColor: string
    }
    selectedColor: string
    unselectedColor: string
  }
  isOutOfStock?: boolean
  showRelativePrice?: boolean
}

const RadioAnswer = forwardRef<HTMLDivElement, RadioAnswerProps>(
  (
    { id, selected, name, handleClick, views, price, currency, lang, country, style, isOutOfStock, showRelativePrice },
    ref
  ) => {
    const iconColor = selected ? style.selectedColor : style.unselectedColor
    const fontView = !!views ? (views?.[0] as FontView) : undefined

    return (
      <div ref={ref} className="radio-answer-container" onClick={() => handleClick(id)} data-testid="radio-answer">
        <div
          className={classNames('radio-answer-container__icon', {
            'radio-answer-container__icon--selected': selected,
          })}
        >
          <RadioIcon selected={selected} iconColor={iconColor} width={15} />
        </div>

        <div className="radio-answer-container__text">
          {!!fontView && !isNullOrEmpty(fontView.assets) ? (
            <FontPreview fontView={fontView} text={name} style={style.text} />
          ) : (
            <div style={style.text}>
              {name}{' '}
              {isOutOfStock && (
                <>
                  (<Translation field="outOfStock" />)
                </>
              )}
            </div>
          )}
          <ExtraPriceLabel
            extraClassNames="price-label__radio"
            currency={currency}
            lang={lang}
            country={country}
            price={price}
            showRelativePrice={showRelativePrice}
          />
        </div>
      </div>
    )
  }
)

export default RadioAnswer
